function anchorOffsetFor(style) {
  const { width, height } = style;
  switch (style.anchor) {
    case "NORTH":
      return [width / 2, 0];
    case "NORTH_EAST":
      return [width, 0];
    case "EAST":
      return [width, height / 2];
    case "SOUTH_EAST":
      return [width, height];
    case "SOUTH":
      return [width / 2, height];
    case "SOUTH_WEST":
      return [0, height];
    case "WEST":
      return [0, height / 2];
    case "NORTH_WEST":
      return [0, 0];
    case "CENTER":
      return [width / 2, height / 2];
    default:
      return [0, 0];
  }
}

export function topLeftAnchorPosition(style) {
  const [anchorLeft, anchorTop] = anchorOffsetFor(style);

  return {
    anchorLeft: anchorLeft + (style.anchorOffsetX || 0),
    anchorTop: anchorTop + (style.anchorOffsetY || 0)
  };
}

export default function calculateAnchorOffset(style) {
  const [anchorLeft, anchorTop] = anchorOffsetFor(style);

  return {
    anchorLeft: -(anchorLeft + (style.anchorOffsetX || 0)),
    anchorTop: -(anchorTop + (style.anchorOffsetY || 0))
  };
}
